import { useEffect, useState } from "react";
import userService from "../../../services/userService";
import { userRoles } from "../../../helpers/constant";

const ADMIN_ROLES = [userRoles.ADMIN, userRoles.OWNER];

// Facility admins shown in the header ("2 admins"). Derived from the existing
// users list rather than a new endpoint -- there is no dedicated
// "facility admins" API today.
export function useFacilityAdmins(facilityNumber) {
  const [admins, setAdmins] = useState([]);

  useEffect(() => {
    if (!facilityNumber) return;
    userService
      .getAllUsers(`?facility_id=${facilityNumber}`)
      .then((users) => {
        const adminUsers = (users || []).filter((user) => ADMIN_ROLES.includes(user.role));
        setAdmins(adminUsers);
      })
      .catch((error) => {
        console.error("Error fetching facility admins:", error);
        setAdmins([]);
      });
  }, [facilityNumber]);

  return admins;
}
